import React from 'react';
import Footer from '../component/Footer';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is included

const Reconstructive = () => {
  return (
    <>
      <div className="container my-5">
        <h1 className="text-center mb-4">Reconstructive Urology Care</h1>

        <section className="mb-4">
          <h2>Laser Endoscopic DVIU / OIU for Urethral Strictures</h2>
          <p className="text-justify">
            One of the most advanced treatments available for short urethral strictures is laser endoscopic surgery, specifically
            Direct Vision Internal Urethrotomy (DVIU) or Optical Internal Urethrotomy (OIU). These minimally invasive procedures are
            ideal for addressing urethral strictures, which are characterized by a narrowing of the urethra, often caused by scarring
            from surgery or injury.
          </p>

          <h5>Urethral Strictures Symptoms Include:</h5>
          <ul>
            <li>Decreased urine stream</li>
            <li>Incomplete bladder emptying</li>
            <li>Pain or straining during urination</li>
            <li>Increased frequency of urination</li>
          </ul>

          <p className="text-justify">
            DVIU and OIU utilize a laser to carefully cut through scar tissue within the urethra. This procedure is performed under local
            anesthesia and is often done on an outpatient basis, allowing patients to return home within a few hours. Though minimally
            invasive, this treatment has a lower success rate compared to more advanced techniques like urethroplasty.
          </p>
        </section>

        <section className="mb-4">
          <h2>Buccal Mucosal Urethroplasty</h2>
          <p className="text-justify">
            In cases where the scar tissue in the urethra is extensive, buccal mucosal urethroplasty may be recommended. This is a
            reconstructive surgery where tissue from the inside of your cheek is grafted to repair the urethra. The graft promotes
            healing and helps restore normal function to the urethra, allowing urine to pass through the urethra without obstruction.
          </p>

          <h5>What to Expect with Urethroplasty:</h5>
          <ul>
            <li>Tissue is taken from the buccal mucosa (inner cheek lining).</li>
            <li>The tissue is grafted into the urethra to replace the damaged or scarred section.</li>
          </ul>

          <p className="text-justify">
            This procedure is highly effective for more severe cases of urethral stricture.
          </p>
        </section>

        <section className="mb-4">
          <h2>Bladder Augmentation Surgery</h2>
          <p className="text-justify">
            Bladder augmentation is often necessary when the bladder's capacity is insufficient to store urine, leading to issues such
            as frequent urination, urgency, or incontinence. This can be caused by congenital abnormalities, injury, or diseases like
            GUTB (genitourinary tuberculosis).
          </p>

          <p className="text-justify">
            Using laparoscopic techniques, we can enhance the bladder’s size and function. Bladder augmentation is especially suited for
            cases with GUTB, which can result in damage to the bladder and urinary system. This minimally invasive procedure involves
            making small incisions and using a camera (laparoscope) to access the bladder, making it less invasive with faster recovery
            times compared to traditional surgery.
          </p>
        </section>

        <section className="mb-4">
          <h2>Laparoscopic Surgery for Small Bladder</h2>
          <p className="text-justify">
            In cases where GUTB causes a severely diminished bladder size, laparoscopic bladder augmentation is one of the most advanced
            treatments. This minimally invasive technique allows surgeons to access the abdomen and pelvis with tiny incisions and use
            a laparoscope to assist in reconstructing the bladder.
          </p>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default Reconstructive;
